import React, { FunctionComponent } from 'react';
import { CircleBadge } from '@iba-team/portal-react-components/dist';

export interface AbsenceItemProps {
text: string,
balance: number | string,
badgeColor: string
width?: string
}

export const AbsenceItem: FunctionComponent<AbsenceItemProps> = (props) => {
  return (
    <div className={'absence_item'} style={{width: props.width}}>
      <CircleBadge  color={props.badgeColor} text={props.text}/>
      <div className={'absence_item_balance'}>{props.balance}</div>
    </div>
  );
};
